/**
 * Build Highcharts / chart download filenames from the widget title
 * (not PrismId), appending active filter values.
 */
export function buildChartExportFileName(
  title: unknown,
  filterValues: Record<string, any> | null | undefined,
  fallback: unknown = 'chart',
  options?: { omitFilterKeys?: string[] },
): string {
  const resolvedTitle = typeof title === 'string' ? title.trim() : '';
  const resolvedFallback = typeof fallback === 'string' && fallback.trim().length > 0 ? fallback.trim() : 'chart';
  let fileName = resolvedTitle || resolvedFallback;

  if (filterValues && typeof filterValues === 'object') {
    const omit = new Set(options?.omitFilterKeys ?? []);
    Object.keys(filterValues).forEach(key => {
      if (omit.has(key)) return;
      const value = filterValues[key];
      if (value === undefined || value === null || value === '') return;
      fileName += `_${value}`;
    });
  }

  return fileName;
}
